import React, { useState } from 'react';
import { InputHLPure, PanelBarGLPure, TextAreaHLPure, CheckBoxHLPure } from '../../pures';
import { Grid } from '@material-ui/core'
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import { ChipList, Chip } from "@progress/kendo-react-buttons";
import { useTranslation } from "react-i18next"

const DocumentPanelBarBasicData = (props) => {

    let {
        handleChangeDescription,
        description,
        tags,
        transaction,
        handleTransaction,
        monetaryUnit,
        handleMonetaryUnit,
        penaltyFee,
        handlePenaltyFee,
        confidentialCheck,
        onChangeCheckBoxConfidential,
        obligatoryCheck,
        onChangeCheckBoxObligatory,
        documentData,
        showCircle,
        handleDeleteChipTag,
        removeTags
    } = props
    const { t } = useTranslation()

    let pathColor = (documentData && documentData.daysTo && documentData.daysTo > 0) ? '#559DD9' : 'red'
    let textColor = (documentData && documentData.daysTo && documentData.daysTo > 0) ? '#559DD9' : 'red'

    const TagChip = (props) => {
        return (
            <Chip
                {...props}
                disabled={false}
            // style={{
            //   backgroundColor: '#F5F5F5',
            // }}
            />
        );
    };
    return (
        <PanelBarGLPure
            expandedPanel={true}
            titlePanel={t("documentPanelBarBasicData.basic.data")}
            className='documentPanelBarBasicData'
        >
            <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                disableGutters
                className='documentPanelBarBasicData-container'
            >
                <div className='documentPanelBarBasicData-dates-circle'>
                    <div className='documentPanelBarBasicData-dates'>
                        <h1>{t("documentPanelBarBasicData.date.celebration")}</h1>
                        <h2>{(documentData.startDate) ? documentData.startDate : ''}</h2>

                        <h1>{t("documentPanelBarBasicData.date.due")}</h1>
                        <h2>{(documentData.validationDate) ? documentData.validationDate : ''}</h2>
                    </div>
                    {
                        showCircle && (
                            <div className='documentPanelBarBasicData-circle-container'>
                                <h1>{t("documentPanelBarBasicData.expires")}</h1>
                                <div className='documentPanelBarBasicData-circle'>
                                    <CircularProgressbarWithChildren
                                        value={documentData.percent}
                                        styles={buildStyles({
                                            pathColor: pathColor
                                        })}
                                    >
                                        <div className='documentPanelBarBasicData-circle-children'>
                                            <h1 style={{ color: textColor }}>{documentData.daysTo}</h1>
                                            <h2>{t("documentPanelBarBasicData.days")}</h2>
                                        </div>
                                    </CircularProgressbarWithChildren>
                                </div>
                            </div>
                        )
                    }
                </div>
                <div className='documentPanelBarBasicData-description'>
                    <TextAreaHLPure
                        labelTextArea={t("documentPanelBarBasicData.description")}
                        valueTextData={description}
                        handleChangeTextArea={(e) => handleChangeDescription(e)}
                        disabled
                    />
                </div>
                <div className='documentPanelBarBasicData-transaction-container'>
                    <div className=''>
                        <div className='documentPanelBarBasicData-transaction'>
                            <InputHLPure
                                typeInput="text"
                                labelInput={t("documentPanelBarBasicData.transaction.value")}
                                valueInput={transaction}
                                handleChangeInput={(e) => handleTransaction(e)}
                                tooltipShow={false}
                                informationIcon={false}
                                inputActive={true}
                                disabled
                            />
                        </div>
                        <div className='documentPanelBarBasicData-transaction'>
                            <InputHLPure
                                typeInput="text"
                                labelInput={t("digitalVault.editDocument.combobox.currencyType")}
                                valueInput={monetaryUnit}
                                handleChangeInput={(e) => handleMonetaryUnit(e)}
                                tooltipShow={false}
                                informationIcon={false}
                                inputActive={true}
                                disabled
                            />
                        </div>
                    </div>
                    <div className='documentPanelBarBasicData-checkBox-container'>
                        <div className="documentPanelBarBasicData-checkBox-transaction">
                            <CheckBoxHLPure
                                checkedState={confidentialCheck}
                                onChangeHandler={(e) => onChangeCheckBoxConfidential(e)}
                                disabled
                            />
                            <h1>{t("documentPanelBarBasicData.confidential")}</h1>
                        </div>
                        <div className="documentPanelBarBasicData-checkBoxs">
                            <CheckBoxHLPure
                                checkedState={obligatoryCheck}
                                onChangeHandler={(e) => onChangeCheckBoxObligatory(e)}
                                disabled
                            />
                            <h1 >{t("documentPanelBarBasicData.obligatory")}</h1>
                        </div>
                        <div className="documentPanelBarBasicData-checkBox-penalty">
                            <CheckBoxHLPure
                                checkedState={penaltyFee}
                                onChangeHandler={(e) => handlePenaltyFee(e)}
                                disabled
                            />
                            <h1 >{t("documentPanelBarBasicData.penalty")}</h1>
                        </div>
                    </div>
                    <div className="documentPanelBarBasicData-tags">
                        <h1 >{t("digitalVaultFollowUpDocument.tags")}</h1>
                        <ChipList
                            selection="single"
                            data={tags}
                            chip={TagChip}
                        />
                    </div>

                </div>
            </Grid>
        </PanelBarGLPure>
    )
}

export default DocumentPanelBarBasicData